// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../api/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type UploadProjectSpatialFileMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID'];
  file: Types.Scalars['Upload'];
}>;


export type UploadProjectSpatialFileMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly uploadProjectSpatialFile?: Types.Maybe<(
    { readonly __typename: 'UploadProjectSpatialFileResult' }
    & Pick<Types.UploadProjectSpatialFileResult, 'success' | 'message' | 'uploadPath'>
  )> }
);


export const UploadProjectSpatialFileDocument = gql`
    mutation UploadProjectSpatialFile($projectId: ID!, $file: Upload!) {
  uploadProjectSpatialFile(projectId: $projectId, file: $file) {
    success
    message
    uploadPath
  }
}
    `;
export type UploadProjectSpatialFileMutationFn = Apollo.MutationFunction<UploadProjectSpatialFileMutation, UploadProjectSpatialFileMutationVariables>;

/**
 * __useUploadProjectSpatialFileMutation__
 *
 * To run a mutation, you first call `useUploadProjectSpatialFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProjectSpatialFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProjectSpatialFileMutation, { data, loading, error }] = useUploadProjectSpatialFileMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadProjectSpatialFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadProjectSpatialFileMutation, UploadProjectSpatialFileMutationVariables>) {
        return Apollo.useMutation<UploadProjectSpatialFileMutation, UploadProjectSpatialFileMutationVariables>(UploadProjectSpatialFileDocument, baseOptions);
      }
export type UploadProjectSpatialFileMutationHookResult = ReturnType<typeof useUploadProjectSpatialFileMutation>;
export type UploadProjectSpatialFileMutationResult = Apollo.MutationResult<UploadProjectSpatialFileMutation>;
export type UploadProjectSpatialFileMutationOptions = Apollo.BaseMutationOptions<UploadProjectSpatialFileMutation, UploadProjectSpatialFileMutationVariables>;